import { initialState } from 'store/reducers/reducer';
const devTools = window.__REDUX_DEVTOOLS_EXTENSION__?.connect({});
if (devTools)
    devTools.init(initialState);
export function storeDevtoolsMiddleware(reducer) {
    if (!devTools) {
        return reducer;
    }
    return (state, action) => {
        const updatedState = reducer(state, action);
        devTools.send(action, updatedState);
        return updatedState;
    };
}
